import { Box, Grid, Typography } from '@material-ui/core';
import { formatDateString } from '../../../utils/common';
import { Trans, useTranslation } from 'react-i18next';
import LocaleKeys from '../../../locales/keys';

const CurrentSubscription = (props) => {
  const { classes, thumbnailUrl, currentCycleEnd, refundAmount } = props;
  const { t } = useTranslation();
  return (
    <Grid item container>
      <Grid item container>
        <Grid item>
          <Box
            p={2}
            style={{
              backgroundColor: '#EBEBEB',
              marginBottom: '16px',
              borderRadius: '4px',
            }}
          >
            <Typography
              style={{
                color: '#15151E',
                fontSize: '14px',
                fontWeight: '700',
                letterSpacing: '0.5%',
                WebkitFontSmoothing: 'auto',
                textTransform: 'uppercase'
              }}
            >
              {t(LocaleKeys.subscriptionInfo.subscriptions.current)}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12} lg={6} className={classes.reviewOrderDetailsImage}>
        <img
          style={{ height: '25px' }}
          src={thumbnailUrl}
          alt="order-summary-product-thumbnail"
        />
      </Grid>
      <Grid item>
        <Typography>
          <Trans
            i18nKey={
              LocaleKeys.subscriptionInfo.subscriptions.upgradeOrderHelperText
            }
            components={{ bold: <strong /> }}
            values={{
              cycleEndDate: formatDateString(currentCycleEnd),
              renewAmount: refundAmount.priceWithCurrencySymbol,
            }}
          />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CurrentSubscription;
